export default "/static/assets/target-dollar.2a31c5c4470e2dc42869ddec01ae7624.svg";